export default __webpack_public_path__ + "static/glass-1-75bd424c06264d7ffc6fae14a1c33069.jpg";